<template>
  <el-dialog :visible.sync="dialogFormVisible" :title="titles[updateType]" :before-close="close" :close-on-click-modal="false">
    <el-form ref="form" label-width="160px" :model="initForm" :rules="rules">

      <el-form-item label="订阅者名称" prop="name">
        <el-input v-model="initForm.name" placeholder="请输入订阅者名称"></el-input>
      </el-form-item>

      <!-- <el-form-item label="订阅者邮箱" prop="email">
        <el-input v-model="initForm.email" placeholder="请输入Email"></el-input>
      </el-form-item> -->

      <el-form-item label="收件邮箱" prop="email">
        <template slot="label">
          收件邮箱
          <el-tooltip effect="dark" content="请填写收件邮箱, 一行一个email" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <el-input type="textarea" :rows="5" v-model="initForm.email" placeholder="请填写收件邮箱, 一行一个email"></el-input>
      </el-form-item>

      <el-form-item label="抄送邮箱" prop="cc_email">
        <template slot="label">
          抄送邮箱
          <el-tooltip effect="dark" content="请填写抄送邮箱, 一行一个email" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <el-input type="textarea" :rows="5" v-model="initForm.cc_email" placeholder="请填写抄送邮箱, 一行一个email"></el-input>
      </el-form-item>

      <el-form-item label="密件抄送邮箱" prop="bc_email">
        <template slot="label">
          密件抄送邮箱
          <el-tooltip effect="dark" content="请填写密件抄送邮箱, 一行一个email" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <el-input type="textarea" :rows="5" v-model="initForm.bc_email" placeholder="请填写抄送邮箱, 一行一个email"></el-input>
      </el-form-item>

      <el-form-item label="邮件模板" prop="template_type">
        <el-select v-model="initForm.template_type" placeholder="请选择邮件模板">
        <el-option
          v-for="email_template in emailTemplateTypes"
          :label="email_template.name"
          :key="email_template.value"
          :value="email_template.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="是否订阅Dis业务数据" prop="dis_business_subscription">
        <el-select v-model="initForm.dis_business_subscription" placeholder="是否订阅Dis业务数据">
        <el-option
          v-for="dis_business_subscription in businessDisStatus"
          :label="dis_business_subscription"
          :key="dis_business_subscription"
          :value="dis_business_subscription"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="备注">
        <el-input type="textarea" :rows="4" v-model="initForm.remark" placeholder="请填写备注"></el-input>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">提交</el-button>
      <el-button @click="$emit('close')" type="info">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { HasStatus, SubscriberEmailTemplateTypes } from "@/components/Index/data.js";

export default {
  props: {
    initForm: {},
    updateType: {},
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        name: [{required: true, message: "请输入订阅者名称", trigger: "blur"}],
        email: [{required: true, message: "请输入订阅者邮箱", trigger: "blur"}],
        dis_business_subscription: [{required: true, message: "是否订阅Dis业务数据", trigger: "blur"}],
        template_type: [{required: true, message: "请选择邮件模板", trigger: "blur"}],
      },
      titles: {
        add: "新增",
        edit: "编辑"
      },
      businessDisStatus: HasStatus,
      emailTemplateTypes: SubscriberEmailTemplateTypes,
    };
  },
  created() {
    if (this.updateType === 'edit') {
      this.initForm.dis_business_subscription = this.initForm.dis_business_subscription ? '是' : '否';
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        var method = "";
        var url = "";
        var msg = "操作失败";
        var formData = {
              name: this.initForm.name,
              email: this.initForm.email,
              cc_email: this.initForm.cc_email,
              bc_email: this.initForm.bc_email,
              dis_business_subscription: +(this.initForm.dis_business_subscription === '是'),
              template_type: typeof this.initForm.template_type === 'string' 
                ? (this.emailTemplateTypes.find(t => t.name === this.initForm.template_type) || {}).value
                : this.initForm.template_type,
              remark: this.initForm.remark,
            };

        if (!valid) {alert("请检查输入是否正确！"); return false;};
        // this.dialogFormVisible = false;
        if (this.updateType === "add") {
          method = "post";
          url = "subscriber/subscriber/";
          msg = "添加成功";
        } else if (this.updateType === "edit") {
          method = "patch";
          url = "subscriber/subscriber/" + this.initForm.id + "/";
          msg = "编辑成功";
        } else{
          return false;
        };
        this.$http[method](
          url,
          formData,
          () => {
            this.$baseNotice.message(msg);
            this.$emit("close");
            this.$emit("update");
          }
        )
      });
    }
  }
};
</script>